import { AppSettings } from './appsettings';

export interface IText {
	fi: string;
	sv: string;
	en: string;
}

export function translate(text: IText): string {
	return text != null ? text[AppSettings.lang] : '';
}
